import React from 'react';
import { Typography, Divider, Card, Space } from 'antd';

const { Title, Paragraph, Text } = Typography;

const ShippingPolicy: React.FC = () => {
  return (
    <div className='container mx-auto py-12 px-4'>
      <Title level={2} className='text-center mb-8'>
        Shipping Policy
      </Title>

      <Card className='mb-8'>
        <Space direction='vertical' className='w-full' size='large'>
          <div>
            <Title level={4}>Delivery Areas</Title>
            <Paragraph>
              We currently deliver to all major cities and surrounding areas. To
              check if we deliver to your location, please enter your postal
              code in the delivery checker on our homepage or contact our
              customer service.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Delivery Times</Title>
            <Paragraph>
              <Text strong>• Standard Delivery:</Text> Orders are typically
              delivered within 1-2 business days after order confirmation.
            </Paragraph>
            <Paragraph>
              <Text strong>• Express Delivery:</Text> Orders placed before 10 AM
              can be delivered on the same day (additional charges apply).
            </Paragraph>
            <Paragraph>
              <Text strong>• Scheduled Delivery:</Text> You can choose a
              specific delivery date and time slot during checkout.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Shipping Fees</Title>
            <Paragraph>
              <Text strong>• Orders above $50:</Text> Free standard shipping
            </Paragraph>
            <Paragraph>
              <Text strong>• Orders below $50:</Text> $5.99 shipping fee
            </Paragraph>
            <Paragraph>
              <Text strong>• Express Delivery:</Text> Additional $7.99
            </Paragraph>
            <Paragraph>
              <Text strong>• Remote Areas:</Text> Additional surcharge may apply
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Order Tracking</Title>
            <Paragraph>
              Once your order is dispatched, you will receive a confirmation
              email with a tracking number. You can use this number to track
              your order on our website under "Order History" in your account
              dashboard.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Delivery Issues</Title>
            <Paragraph>
              In case of missing, damaged, or incorrect items, please contact
              our customer service within 24 hours of delivery. We will resolve
              the issue as quickly as possible, which may include refunds or
              replacements as appropriate.
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={4}>Perishable Items Policy</Title>
            <Paragraph>
              As we deal with fresh fruits, we take extra care in packaging and
              shipping. However, due to the perishable nature of our products,
              we recommend that you inspect your order immediately upon delivery
              and store items appropriately.
            </Paragraph>
            <Paragraph>
              We cannot accept returns of perishable items unless they arrive in
              damaged or unusable condition.
            </Paragraph>
          </div>
        </Space>
      </Card>

      <div className='text-center'>
        <Paragraph type='secondary'>
          This shipping policy was last updated on October 1, 2023. We reserve
          the right to make changes to our shipping policy at any time.
        </Paragraph>
      </div>
    </div>
  );
};

export default ShippingPolicy;
